module.exports = __webpack_public_path__ + "static/media/skeleton2.967c2685.gif";